import React from 'react';
import {ColumnComponent} from './base/column.component';
import {TextField} from '@mui/material';

interface SearchFiledProps {
  searchText: string;
  type: string;
  searchTag: string;
  onChangeText: any;
}

export const SearchFiled: React.FC<SearchFiledProps> = (props) => {
  return (
    <ColumnComponent className="totalCenter py-2">
      <TextField
        autoComplete="off"
        value={props.searchText}
        type={props.type}
        onChange={props.onChangeText}
        className="searchBox mb-2 mt-1"
        label={props.searchTag}
        placeholder={props.searchTag}
        variant={'outlined'}
      />
    </ColumnComponent>
  );
};
